import React from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import { Image } from "@learningblocks/shared-components/lib/Image";

import GB_CLOSED from "./img/GelBox.svg";
import GB_OPEN from "./img/GelBoxOpen.svg";
import GB_BUFFER_CLOSED from "./img/GelBoxBuffer.svg";
import GB_BUFFER_OPEN from "./img/GelBoxBufferOpen.svg";
import GB_FULL_CLOSED from "./img/GelBoxFull.svg";
import GB_FULL_OPEN from "./img/GelBoxFullOpen.svg";
import GB_FULL_BUFFER_CLOSED from "./img/GelBoxFullBuffer.svg";
import GB_FULL_BUFFER_OPEN from "./img/GelBoxFullBufferOpen.svg";

export function GelboxImage(props) {
  const { t } = useTranslation();

  const getImage = () => {
    let image = GB_CLOSED;

    // Has buffer
    if (props.volume > 0) {
      if (props.containsGel) {
        if (props.open) {
          image = GB_FULL_BUFFER_OPEN;
        } else {
          image = GB_FULL_BUFFER_CLOSED;
        }
      } else {
        if (props.open) {
          image = GB_BUFFER_OPEN;
        } else {
          image = GB_BUFFER_CLOSED;
        }
      }
    } else {
      if (props.containsGel) {
        if (props.open) {
          image = GB_FULL_OPEN;
        } else {
          image = GB_FULL_CLOSED;
        }
      } else {
        if (props.open) {
          image = GB_OPEN;
        } else {
          image = GB_CLOSED;
        }
      }
    }

    return image;
  };

  const onClick = (event) => {
    event.stopPropagation();
    props.onSelect(!props.open);
  };

  return (
    <div
      className="gelbox__image"
      role="button"
      tabIndex="0"
      onClick={onClick}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") {
          onClick;
        }
      }}
    >
      <Image
        style={{ cursor: "pointer" }}
        src={getImage()}
        alt={t("GelboxImage.string")}
      />
    </div>
  );
}

GelboxImage.propTypes = {
  /**
   * Boolean to set if apparatus is open/closed
   */
  open: PropTypes.bool,

  containsGel: PropTypes.bool,
  volume: PropTypes.int,
  /**
   * function to invoke when Image is clicked
   */
  onSelect: PropTypes.func,
};

GelboxImage.defaultProps = {};
